module.exports = __webpack_public_path__ + "img/emil.da05a66a.svg";